export interface PropertyLocation {
    readonly buildingId?: string;
    readonly houseNumberId?: string;
    readonly parcelId?: string;
    readonly streetId?: string;
    readonly blockId?: string;
    readonly microStatisticalUnitId?: string;
    readonly statisticalUnitId?: string;
    readonly microNeighborhoodId?: string;
    readonly neighborhoodId?: string;
    readonly macroNeighborhoodId?: string;
    readonly boroughId?: string;
    readonly municipalityId?: string;
    readonly countyId?: string;
    readonly provinceId?: string;
    readonly microRegionId?: string;
    readonly regionId?: string;
    readonly macroRegionId?: string;
    readonly countryId?: string;

    readonly latitude: number;
    readonly longitude: number;
}
export interface LegacyPropertyLocation {
    readonly addressId?: string;
    readonly buildingId?: string;
    readonly parcelId?: string;
    readonly streetId?: string;
    readonly blockId?: string;
    readonly irisId?: string;
    readonly boroughId?: string;
    readonly neighborhoodId?: string;
    readonly arrmunId?: string;
    readonly subcityId?: string;
    readonly cityId: string;
    readonly districtId?: string;
    readonly subregionId?: string;
    readonly regionId?: string;
    readonly countryId?: string;

    readonly latitude: number;
    readonly longitude: number;
}

export function getMostPreciseGeoPlaceIdFromLocation(
    location: PropertyLocation,
): string | undefined {
    return (
        location.buildingId ??
        location.houseNumberId ??
        location.parcelId ??
        location.streetId ??
        location.blockId ??
        location.microStatisticalUnitId ??
        location.statisticalUnitId ??
        location.microNeighborhoodId ??
        location.neighborhoodId ??
        location.macroNeighborhoodId ??
        location.boroughId ??
        location.municipalityId
    );
}
